import { UserDataForm } from '../../../components/forms/UserDataForm';

import { BaseModal } from './EditProfileRoute';
import { useCustomerContext } from '../../../components/CustomerProvider.tsx';

export function EditLanguageRoute() {
    const { user, refetchUser } = useCustomerContext();
    return (
        <BaseModal
            open={true}
            user={user}
            refetchUser={refetchUser}
            render={(control, requestState, submit) => (
                <UserDataForm.LanguageField
                    control={control}
                    requestStatus={requestState.status}
                    submit={submit}
                />
            )}
            noCancelSaveButton={true}
        />
    );
}
